import React from "react";
import PropTypes from "prop-types";
import { Graphics } from "./components/Graphics";

import "./style.scss";

import { Graphics as Solution } from "../Solution/components/Graphics"

export class IceBucket extends React.Component {
  componentWillMount() {
    this.props.createIceBucket({
      props: this.props.defaultProps,
    });
  }

  getLabel = (solution) => {

    const { labelReactionTubes } = this.props
    const { renamable, solutionAlias, fullName } = this.props.interactionProps.solutions[solution.id-1]

    if (!labelReactionTubes && renamable) {
      return solutionAlias
    }
    return fullName
  }


  getIceBucketSolutions = () => {
    let solutions = this.props.solutions.map((solution, index)=>{
      if(solution.id !== null){
        return (
          <li
              draggable
              onDragStart={(e)=>{
                this.props.setSolutionHeld({
                  id: solution.id,
                  held: true,
                })
                this.props.setHeldObject({
                  id: solution.id,
                  type: 'Solution',
                  htmlObj: e.target,
                })
              }}
              onDragEnd={(e)=>{
                this.props.setSolutionHeld({
                  id: solution.id,
                  held: false,
                })
              }}
              id={'Solution_'+solution.id} tabIndex={0}
              className={'Solution draggable dropTarget'}
              style={{ transform: "translate3d(0px, 0px, 0px) rotateZ(0deg)"}}>
              <p className="label" aria-hidden="true">
                {this.getLabel(solution)}
              </p>
              <Solution id={solution.id} />
          </li>
        )
      } else {
        return(
          <li>
            <div style={{width: "29px", height: "101px"}}></div>
          </li>
        )
      }
    })
    return (
      <div className="IceBucketTubes">
        <ul>
        {solutions}
        </ul>
      </div>
    );
  }

  render() {
    return (
      <ul>
          {(this.props.solutions)?this.getIceBucketSolutions():null}
          <li style={{pointerEvents: "none" }}
              aria-label="Ice Bucket"
              id={"IceBucket_" + this.props.id} tabIndex={0}
              className="dropTarget IceBucket">
              <p aria-hidden="true" className="label">Ice Bucket</p>
              <Graphics id={this.props.id}/>
          </li>
      </ul>
    );
  }
}

IceBucket.propTypes = {
  createIceBucket: PropTypes.func,
};

IceBucket.defaultProps = {};
